import React from "react";
import "./Skills.css";

const Skills = ({ t }) => {
  const skills = [
    {
      name: t.skills.html,
      level: t.skills.htmlLevel,
      icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
    },
    {
      name: t.skills.css,
      level: t.skills.cssLevel,
      icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
    },
    {
      name: t.skills.javascript,
      level: t.skills.jsLevel,
      icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
    },
    {
      name: t.skills.react,
      level: t.skills.reactLevel,
      icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
    },
    {
      name: t.skills.python,
      level: t.skills.pythonLevel,
      icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg",
    },
    {
      name: t.skills.ai,
      level: t.skills.aiLevel,
      icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tensorflow/tensorflow-original.svg",
    },
    {
      name: t.skills.django,
      level: t.skills.djangoLevel,
      icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/django/django-plain.svg",
    },
    {
      name: t.skills.git,
      level: t.skills.gitLevel,
      icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
    },
  ];

  return (
    <section id="skills" className="section skills-section">
      <h2 className="section-title">{t.skills.title}</h2>
      <p className="skills-description">{t.skills.description}</p>
      <div className="skills-container">
        {skills.map((skill, index) => (
          <div key={index} className="skill-item">
            <div className="skill-header">
              <span className="skill-name">
                {skill.icon ? (
                  <img
                    src={skill.icon}
                    alt=""
                    className="skill-icon"
                    loading="lazy"
                    onError={(e) => {
                      e.currentTarget.style.display = "none";
                    }}
                  />
                ) : null}
                {skill.name}
              </span>
              <span className="skill-level">{skill.level}</span>
            </div>
            <div className="skill-bar">
              <div
                className="skill-progress"
                style={{
                  width:
                    skill.level === t.skills.pythonLevel ||
                    skill.level === t.skills.gitLevel
                      ? "85%"
                      : skill.level === t.skills.htmlLevel ||
                        skill.level === t.skills.cssLevel ||
                        skill.level === t.skills.jsLevel
                      ? "70%"
                      : "50%",
                }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Skills;
